export default function () {

    document.addEventListener('click', (event) => {
        let el = event.target;
        if (el.classList.contains('youtube-click')) {
            let iframe = document.createElement('IFRAME');
            let url = el.dataset.embed;
            if (url.match(/\?/)) {
                url += '&autoplay=1';
            } else {
                url += '?autoplay=1';
            }
            iframe.src = url;
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.classList.add('w-full');
            iframe.classList.add('h-80');
            iframe.classList.add('mx-auto');
            iframe.frameBorder = 0;
            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
            iframe.setAttribute('allowFullScreen', '')
            el.parentNode.replaceChild(iframe, el);
        }
    })
}